export const SET_PAID_DRIVERS = 'SET_PAID_DRIVERS';


export const actionSetPaidDrivers = paidDriver => ({
    type: SET_PAID_DRIVERS,
    payload: paidDriver
})

